import "core-js/modules/es6.string.small";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TitleSection from '~/components/atoms/Editorial/TitleSection.vue';
import SubtitlePage from '~/components/atoms/Editorial/SubtitlePage.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
export default {
  name: 'SimpleHeaderBackground',
  components: {
    TitleSection: TitleSection,
    SubtitlePage: SubtitlePage,
    SimpleParagraph: SimpleParagraph
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      desktop: true,
      bgset: ''
    };
  },
  computed: {
    title: function title() {
      return {
        text: this.payload.primary.title[0] || {},
        color: this.payload.primary.title_color
      };
    },
    subtitle: function subtitle() {
      return {
        text: this.payload.primary.subtitle[0] || {},
        color: this.payload.primary.subtitle_color
      };
    },
    simpleParagraph: function simpleParagraph() {
      return this.payload.primary.simple_paragraph || [];
    },
    readMore: function readMore() {
      return this.payload.primary.read_more === 'Yes';
    },
    background: function background() {
      return {
        color: this.payload.primary.background_color,
        image: {
          small: formatPrismicImage(this.payload.primary.background_image.small.url, ['w_375']) || EMPTY_PIXEL,
          medium: formatPrismicImage(this.payload.primary.background_image.small.url, ['w_375,dpr_2']) || EMPTY_PIXEL,
          large: formatPrismicImage(this.payload.primary.background_image.url, ['w_1440']) || EMPTY_PIXEL,
          xlarge: formatPrismicImage(this.payload.primary.background_image.url, ['w_1440,dpr_2']) || EMPTY_PIXEL
        }
      };
    }
  },
  mounted: function mounted() {
    this.loaded = true;
    this.bgset = "\n        ".concat(this.background.image.medium, " [(max-width: 768px)] |\n        ").concat(this.background.image.large, " [(max-width: 1440px)] |\n        ").concat(this.background.image.xlarge, " [(max-width: 2880px)]");
    this.desktop = this.isDesktop();
  }
};